module.exports = __webpack_public_path__ + "img/gang.cb19fe45.jpg";